import { WemoloMenuOption } from './index'

export type LegacyOption = { id?: string | number; label?: string }

export const toMenuOptions = (options: LegacyOption[]): WemoloMenuOption[] =>
    options.map(({ id, label }) => ({ value: id == null ? '' : String(id), label: label ?? '' }))

export const findOptionById = <T extends LegacyOption>(options: T[], id: string | undefined): T | undefined =>
    id === undefined ? undefined : options.find((o) => String(o.id ?? '') === id)
